import { createIntegratorChild } from '@nsftx/seven-client-sdk-integrator';

import type { IntegratorEvents } from '../application/ports';

export function createChildIntegratorInstance(
  environment: string,
  providerId: number,
  version: string,
  displayId: string,
  debug: boolean,
  events: IntegratorEvents,
) {
  return createIntegratorChild({
    context: {
      env: environment === 'staging' ? 'staging' : 'production',
      debug,
    },
    app: {
      id: crypto.randomUUID(),
      version,
      displayId,
      providerId,
    },
    events,
  });
}
